exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.mdb {\n  -webkit-padding-start: 0;\n          padding-inline-start: 0; }\n\n.dashboard-links li {\n  width: 130px;\n  height: 110px;\n  display: inline-block; }\n\n.dashboard-router-button {\n  text-decoration: none;\n  display: grid;\n  height: 90%;\n  padding: 10px;\n  margin: 2px;\n  background: rgba(244, 244, 244, 0.9); }\n\n.dashboard-router-button i {\n  font-size: 30px;\n  line-height: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/modules/mobile/views/dashboard/m-dashboard.component.scss
// module id = ../../../../../angular/app/modules/mobile/views/dashboard/m-dashboard.component.scss
// module chunks = main